<div class="pb-6 text-4xl leading-none font-extrabold tracking-tight">{{ title() }}</div>
<div class="flex flex-col gap-12">
  @if (currentUser(); as user) {
    <core-delete-account (deleteAccount)="openDeleteAccountFlow()" />
  }
</div>
